import React, { useState } from 'react';
import { LandingPageWrapper } from 'components';
import { useNavigate } from 'react-router-dom';
import InvalidPermissionsDialog from '../../components/invalid-permissions-dialog/InvalidPermissionsDialog';
import { EDGE_DEFINITION_PATHS } from '../../constants/edge-definition-paths';
import { usePermission } from '../../core';
import { useEdgeDefinitionList } from '../../hooks';
import { EdgeDefinitionsEmptyStateImg } from 'assets/images';
import { EdgeDefinitionType, getColumns } from './edge-definition-helper';

export const EdgeDefinitions = (): React.JSX.Element => {
    const { data: edges, isLoading } = useEdgeDefinitionList();
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();
    const columns = getColumns();

    const handleDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    const handleAdd = (): void => {
        const permission = hasPermissions('createMetadata');
        if (permission) {
            navigate(EDGE_DEFINITION_PATHS.CREATE_NEW_EDGE_DEFINITION);
        } else {
            setDisplayPermissionDialog(true);
        }
    };

    const handleRowClick = (row: EdgeDefinitionType): void => {
        const { id } = row;
        navigate(`${EDGE_DEFINITION_PATHS.LANDING_PAGE}/${id}`);
    };

    return (
        <>
            <LandingPageWrapper
                title={'Edge Definitions'}
                showAddButton={true}
                onAddButtonClick={handleAdd}
                tableData={edges?.data}
                isLoading={isLoading}
                columns={columns}
                getRowId={(row: EdgeDefinitionType): string =>
                    `${row.name}-${row.fromDictionary}-${row.toDictionary}`
                }
                onRowClick={(data: any): void => {
                    handleRowClick(data.row);
                }}
                paginationPageSizeOptions={[25, 50, 100]}
                paginationPageSize={25}
                emptyStateIcon={EdgeDefinitionsEmptyStateImg}
                emptyStateBodyMessage={
                    'Add a new edge using the button at the top right of the screen.'
                }
                sortModel={[{ field: 'name', sort: 'asc' }]}
            />
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handleDialogClose}
                />
            )}
        </>
    );
};
